<template>
  <modal
    :name="name"
    adaptive
    :styles="modalStyles"
    height="auto"
    :scrollable="true"
  >
    <div class="close" @click="closeMe">
      <img src="@/assets/svg/menu-close.svg" />
    </div>
    <div class="modal-inner" :style="modalInnerStyles">
      <slot></slot>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      modalStyles: {
        padding: '20px',
        backgroundColor: 'transparent',
        boxShadow: 'none'
      },
      modalInnerStyles: {
        backgroundColor: '#F19460',
        borderRadius: '30px',
        color: '#FFF',
        padding: '20px'
      }
    };
  },
  computed: {
    modalWidth() {
      return window.innerWidth - 30;
    }
  },
  methods: {
    closeMe() {
      this.$modal.hide(this.name);
    }
  }
};
</script>

<style lang="scss" scoped>
.close {
  background-color: $green;
  border-radius: 50%;
  display: flex;
  height: 44px;
  justify-content: center;
  position: absolute;
  right: 5px;
  top: 5px;
  width: 44px;
}
</style>
